import { msg, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Box, Paper, Typography, useTheme } from '@mui/material'

/**
 * @param {{ summary: { total: number, fatal: number, seriousInjury: number, slightInjury: number, noInjury: number, unknown: number, totalPeople?: number } | null, isLoading?: boolean }} props
 */
export default function DashboardSeveritySummary({ summary, isLoading = false }) {
  const { _ } = useLingui()
  const theme = useTheme()
  const headerColor =
    theme.palette.mode === 'light'
      ? theme.palette.newColors.gray
      : theme.palette.newColors.lightGray

  const items = [
    { key: 'total', label: _(msg`Total crashes`) },
    { key: 'fatal', label: _(msg`Fatal`) },
    { key: 'seriousInjury', label: _(msg`Serious injury`) },
    { key: 'slightInjury', label: _(msg`Slight injury`) },
    { key: 'noInjury', label: _(msg`No injury`) },
    { key: 'unknown', label: _(msg`Unknown`) },
  ]

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, mb: 1.5, color: headerColor }}
      >
        <Trans>Filtered crash summary</Trans>
      </Typography>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(2, minmax(0, 1fr))',
              sm: 'repeat(3, minmax(0, 1fr))',
              md: 'repeat(6, minmax(0, 1fr))',
            },
            gap: 2,
          }}
        >
          {items.map((item) => (
            <Box key={item.key} textAlign="center">
              <Typography variant="caption" sx={{ color: headerColor, display: 'block' }}>
                {item.label}
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 700, color: headerColor }}>
                {isLoading
                  ? '—'
                  : (summary?.[item.key]?.toLocaleString?.() ?? '—')}
              </Typography>
            </Box>
          ))}
        </Box>
      </Paper>
    </Box>
  )
}
